import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadges = () => {
  const securityFeatures = [
    {
      icon: 'Shield',
      title: 'SSL Encrypted',
      description: '256-bit encryption'
    },
    {
      icon: 'Lock',
      title: 'Secure Login',
      description: 'Protected authentication'
    },
    {
      icon: 'CheckCircle2',
      title: 'Verified Platform',
      description: 'Trusted by 50,000+ students'
    }
  ];

  return (
    <div className="mt-8 md:mt-12">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
        {securityFeatures?.map((feature, index) => (
          <div
            key={index}
            className="flex flex-col items-center text-center p-4 md:p-6 bg-muted/30 rounded-lg transition-base hover:bg-muted/50"
          >
            <div className="w-10 h-10 md:w-12 md:h-12 bg-primary/10 rounded-full flex items-center justify-center mb-3 md:mb-4">
              <Icon name={feature?.icon} size={20} color="var(--color-primary)" />
            </div>
            <h3 className="text-sm md:text-base font-semibold text-foreground mb-1 md:mb-2">
              {feature?.title}
            </h3>
            <p className="text-xs md:text-sm text-muted-foreground">
              {feature?.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SecurityBadges;